class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
      const filterItem = document.getElementById("facet-filter-item");
      filterItem.removeAttribute('open');
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    if (event.target.className === "remove-all-filters-button") {
      const customFilters = document.querySelectorAll(".facets-item");
      customFilters.forEach((filter) => {
        filter.classList.remove('active-filter-tab');
      })
    }
  }
}

customElements.define('facet-remove', FacetRemove);

class CustomTabFilters extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.renderCustomFilters.bind(this));
  }

  async renderFilteredProducts(url) {
    try {
      const response = await fetch(url);
      const data = await response.text();
      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(data, 'text/html');
      const newContent = parsedHtml.getElementById('custom-facets').innerHTML;

      const facetsContainer = document.getElementById('custom-facets');
      facetsContainer.innerHTML = newContent;

      facetsContainer.querySelectorAll('.scroll-trigger').forEach(element => {
        element.classList.add('scroll-trigger--cancel');
      });

      const updatedUrl = url.slice(1);
      history.pushState({ updatedUrl }, '', `${window.location.pathname}${url}`);

      const customFilterHeading = document.querySelector(".tabbed-products");
      customFilterHeading.textContent = `Shop ${this.textContent}`;
    } catch (error) {
      console.error('Error fetching filtered products:', error);
    }
  }

  renderCustomFilters() {
    const customFilterItem = this.dataset.customFilterItem;
    const nextSiblings = document.querySelectorAll(".facet__summary-sibling");
    let adjElement = null;

    nextSiblings.forEach(sibling => {
      if (sibling.dataset.filterType === customFilterItem) {
        adjElement = sibling;
      }
    });

    if (adjElement) {
      const inputElements = adjElement.querySelectorAll('.facet-filter-input');
      let filteredProductsUrl = Array.from(inputElements).map(input => {
        return `${input.name}=${input.value.replace(/ /g, "+")}`;
      }).join('&');

      const url = `?${filteredProductsUrl}&sort_by=${sortParamValue || 'manual'}`;

      this.renderFilteredProducts(url);
    }
  }

}

customElements.define('custom-tab-filters', CustomTabFilters);

class CustomSort extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initialSetup();
    this.addClosingEvents();
  }

  initialSetup() {
    // selecting filter element for closing
    const customFiltersElement = [...this.parentElement.children].find(el => el.tagName === 'CUSTOM-FILTERS');
    const customFiltersDetailsElement = customFiltersElement.querySelector("details#facet-filter-item");

    this.label = this.querySelector("label")
    this.optionsContainer = this.querySelector(".sort-options__list");
    this.label.addEventListener("click", () => {
      // for closing filter if open
      const isCustomFilterElementOpen = customFiltersDetailsElement.hasAttribute("open");
      if (isCustomFilterElementOpen) {
        customFiltersDetailsElement.removeAttribute("open");
        customFiltersDetailsElement.open = false;
      }
      this.classList.toggle("active");
    });

    this.allOptionsInput = this.querySelectorAll("li input");
    let currentCheckedInput = this.querySelector("li input[checked]");

    this.allOptionsInput.forEach((option) => {
      option.addEventListener("input", () => {
        currentCheckedInput.removeAttribute("checked");
        currentCheckedInput.checked = false;
        option.setAttribute("checked", "");
        currentCheckedInput = option;
      })
    })
  }

  addClosingEvents() {
    const elementsForCloseSort = this.querySelectorAll("custom-sort-overlay, .list-container__top-bar, .sort-apply--button");
    elementsForCloseSort.forEach(element => {
      element.addEventListener("click", () => {
        const isCustomActive = this.classList.contains("active");
        if (isCustomActive) {
          this.classList.toggle("active");
        }
      });
    });
  }
}

customElements.define('custom-sort', CustomSort);


class CustomFilters extends HTMLElement {
  constructor() {
    super();

    const customFilters = this.querySelectorAll(".facets-item");
    const filtersCloseButton = this.querySelector(".filters-close-button");
    filtersCloseButton.addEventListener('click', (event) => {
      event.preventDefault()
      const filtersTab = this.querySelector('details.facets-item');
      filtersTab.removeAttribute('open')
    })

    const customSortElement = [...this.parentElement.children].find(el => el.tagName === 'CUSTOM-SORT');

    const activetabIndex = sessionStorage.getItem('tab-index');
    setTimeout(() => {
      customFilters.forEach((filterItem, tabIndex) => {
        if (activetabIndex == tabIndex && window.location.search !== '') {
          filterItem.classList.add('active-filter-tab');
        }
        if (tabIndex !== 0 && tabIndex !== customFilters.length - 1) {
          filterItem.addEventListener('click', () => {

            const isCustomSortElementActive = customSortElement.classList.contains("active");
            if (isCustomSortElementActive) customSortElement.classList.remove("active");

            sessionStorage.setItem('tab-index', tabIndex);
            customFilters.forEach((filterTab, index) => {
              filterTab.classList.remove('active-filter-tab');
              if (index === 1 && tabIndex !== index) {
                filterTab.removeAttribute('open')
              }
            })

            filterItem.classList.add('active-filter-tab');
          })
        }
      })
    }, 0.1)

    // for closing filter options on mobile
    const elementsForCloseSort = this.querySelectorAll("custom-filter-overlay, .list-container__top-bar, .filter-apply--button");
    const customFiltersDetailsElement = this.querySelector('details#facet-filter-item');
    elementsForCloseSort.forEach(element => {
      element.addEventListener("click", () => {
        const isCustomFilterElementOpen = customFiltersDetailsElement.hasAttribute("open");
      if (isCustomFilterElementOpen) {
        customFiltersDetailsElement.removeAttribute("open");
        customFiltersDetailsElement.open = false;
      }
      });
    });
  }
}

customElements.define('custom-filters', CustomFilters);


class CollectionSubcategories extends HTMLElement {
  constructor() {
    super();
    this.currentCollectionUrl = window.location.pathname;
    window.addEventListener("popstate", this.checkCollectionUrl);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelectorAll('.collection__subcategory a, .collection__subcategory input').forEach(anchor => {
      anchor.addEventListener('click', event => {
        event.preventDefault();
        const url = new URL(anchor.getAttribute('data-collection-url'), window.location.origin);
        const collectionTitle = anchor.getAttribute('data-collection-title');
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.forEach((value, key) => {
          url.searchParams.append(key, value);
        });

        // Check if the URL has the "?page=1" parameter, and add it if not
        if (!url.searchParams.has('page')) {
          url.searchParams.append('page', '1');
        }

        this.updateSections(url.toString(), collectionTitle);
      });
    });
  }

  checkCollectionUrl = () => {
    const activeCollectionTabInput = this.querySelector('input[checked]');
    if (!activeCollectionTabInput) return;
    const currentUrl = window.location.href;
    const collectionUrl = activeCollectionTabInput.getAttribute('data-collection-url');
    const collectionTitle = activeCollectionTabInput.getAttribute('data-collection-title');
    if (!currentUrl.includes(collectionUrl)) {
      activeCollectionTabInput.removeAttribute('checked');
      activeCollectionTabInput.checked = false;
    }
    this.updateSections(currentUrl, collectionTitle);
  }

  updateSections(url, collectionTitle) {
    const sectionsToUpdate = {
      productGrid: 'main-collection-product-grid'
    };

    const promises = Object.keys(sectionsToUpdate).map(section => {
      const fetchUrl = `${url}&section_id=${sectionsToUpdate[section]}`;
      return fetch(fetchUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector(`#${sectionsToUpdate[section]}`);


          if (newSection) {
            document.querySelector(`#${sectionsToUpdate[section]}`).innerHTML = newSection.innerHTML;
          }
        });
    });

    Promise.all(promises)
      .then(() => {
        window.history.pushState({}, '', url);
        if (collectionTitle) {
          document.title = collectionTitle;
        }
        document.body.classList.remove('overflow-hidden-mobile');
      })
      .catch(error => {
        console.error('Error fetching section HTML:', error);
      });
  }
}

customElements.define('collection-subcategories', CollectionSubcategories);